import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Api } from 'api';
import {
  Col,
  BaseModalProps,
  Modal,
  PrimaryButton,
  SecondaryButton,
  Row,
  error,
  success,
} from '@btc-snxt/ui';

export interface RoleModalProps extends BaseModalProps {
  roleId: string;
}

interface Props extends RoleModalProps {
  setIsParentModalOpen?: React.Dispatch<SetStateAction<boolean>>;
  handleDelete?: () => void;
}

const DeleteRoleModal: React.FC<Props> = (props): JSX.Element => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      await Api.role.role.delete(props.roleId);
      success(t('role.delete_success'));
      props.setIsOpen(false);
      props.setIsParentModalOpen && props.setIsParentModalOpen(false);
      props.handleDelete && props.handleDelete();
    } catch (e) {
      error(t('role.delete_error'));
    }
  };

  return (
    <Modal
      {...props}
      title={t('common.confirmation')}
      size={'sm'}
      components={{
        Footer: () => {
          return (
            <div className={'d-flex justify-content-between'}>
              <Row>
                <Col>
                  <SecondaryButton onClick={handleDelete}>{t('common.yes')}</SecondaryButton>
                </Col>
                <Col>
                  <PrimaryButton
                    onClick={() => {
                      props.setIsOpen(false);
                    }}
                  >
                    {t('common.no')}
                  </PrimaryButton>
                </Col>
              </Row>
            </div>
          );
        },
      }}
    >
      <Row>
        <Col>{t('role.delete_confirm')}</Col>
      </Row>
    </Modal>
  );
};

export default DeleteRoleModal;
